const ROOT = 'CipReport/report/detail';

export const FETCH_DETAIL_REQUEST = `${ROOT}/FETCH_DETAIL_REQUEST`;
export const FETCH_DETAIL_SUCCESS = `${ROOT}/FETCH_DETAIL_SUCCESS`;
export const FETCH_DETAIL_FAILURE = `${ROOT}/FETCH_DETAIL_FAILURE`;
export const SELECTED_ITEM_DETAIL = `${ROOT}/SELECTED_ITEM_DETAIL`;
export const FETCH_REFRESHTOKEN_REQUEST = `${ROOT}/FETCH_REFRESHTOKEN_REQUEST`;
